export default __webpack_public_path__ + "static/media/07.3ae69ad2.webp";